<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4>Detalle Log</h4>

    <div class="row">
        <div class="col-md-12">

            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos del Log
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="intMessage">Mensaje</label>
                                        <input formControlName="Message" name="Message" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Message')" type="text" value="" readonly>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="intMessageTemplate">Plantilla del mensaje</label>
                                        <input formControlName="MessageTemplate" name="MessageTemplate" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('MessageTemplate')" type="text" value="" readonly>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="intLevel">Nivel</label>
                                        <input formControlName="Level" name="Level" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Level')" type="text" value="" readonly>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="intTimeStamp">Registro temporal</label>
                                        <input formControlName="TimeStamp" name="TimeStamp" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('TimeStamp')" type="text" value="" readonly>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="intException">Excepción</label>
                                        <input formControlName="Exception" name="Exception" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Exception')" type="text" value="" readonly>
                                    </div>

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="intProperties">Propiedades</label>
                                        <div class="input-group">
                                            <span class="input-group-btn">
                                                <button name="btnCopyProperties" class="btn btn-list btn-secondary" type="button" title="Copiar"
                                                        (click)="onCopyProperties(properties)">
                                                    <i class="fa fa-copy"></i>
                                                </button>&nbsp;
                                            </span>
                                            <textarea style="resize:none" rows="6" formControlName="Properties" name="Properties" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Properties')" type="text" value="" #properties readonly></textarea>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
